/* unplugin-vue-components disabled */import script from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserMenu.vue?vue&type=script&lang=ts&setup=true"

import "./UserMenu.vue?vue&type=style&index=0&id=4ba064fc&scoped=true&lang=scss"
import "./UserMenu.vue?vue&type=style&index=1&id=4ba064fc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba064fc"]])

export default __exports__